<template>

    <form
            accept-charset="UTF-8"
            role="form"
            id="newsletter-form"
            class="row newsletter-form">

      <div class="offset-lg-1 col-lg-4">

        <p class="newsletter__title">
          Cadastre seu e-mail
        </p>

        <p class="newsletter__title-2">
          E fique por dentro das novidades
        </p>

      </div>

      <div class="col-lg-6 form-inline">

        <div class="form-group">

          <label
                  for="newsletter-name"
                  ref="newsletter-name"
                  class="sr-only">
            Nome
          </label>

          <input
                  type="text"
                  name="name"
                  v-model="newsletter.name"
                  v-validate="'required'"
                  ref="newsletter-name"
                  class="form-control form-control-lg newsletter-form-control"
                  :class="{'error': errors.has('name')}"
                  id="newsletter-name"
                  autocomplete="off"
                  autocorrect="off"
                  placeholder="seu nome"
          >

          <!--<span class="vee-error">{{errors.first('name')}}</span>-->

        </div>

        <div class="form-group">

          <label
                  for="newsletter-email"
                  ref="newsletter-email"
                  class="sr-only">
            Email
          </label>

          <input
                  type="email"
                  name="email"
                  v-model="newsletter.email"
                  v-validate="'required|email'"
                  ref="newsletter-email"
                  class="form-control form-control-lg newsletter-form-control"
                  :class="{'error': errors.has('email')}"
                  id="newsletter-email"
                  autocapitalize="off"
                  autocomplete="off"
                  autocorrect="off"
                  placeholder="seu email"
          >

        </div>

        <btn-send :sending-form="sendingForm"/>

        <span v-if="errors.has('email')" class="vee-error newsletter__vee-error">
          {{errors.first('email')}}
        </span>

      </div>

    </form>

</template>

<script>
  import BtnSend from "./BtnSend.vue";
  import api from "../support/api";

  export default {
    components: {
      BtnSend
    },

    data() {
      return {

        sendingForm: false,

        newsletter: {
          name: "",
          email: "",
        }
      };
    },

    created() {
      bus.$on('newsletter/validateForm', () => {
        this.validateBeforeSubmit();
      });
    },

    methods: {
      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            api.postNewsletter(this);
          } else {
            return this.scrollToFirstError();
          }
        });
      },

      scrollToFirstError() {
        const firstField = Object.keys(this.errors.collect())[0];
        this.$refs[`newsletter-${firstField}`].scrollIntoView();
      },

      // recaptcha() {
      //
      //     let vm = this;
      //
      //     grecaptcha.ready(function() {
      //         grecaptcha.execute(
      //             '6LemDJsUAAAAAIjfUEwWDfks6YwXRT87zIjBxQgY',
      //             {action: 'newsletter'}
      //             ).then(function(token) {
      //                 vm.newsletter.gRecaptchaResponse = token;
      //                 api.postNewsletter(vm);
      //         });
      //     });
      //
      // }
    },
  };
</script>
